export const THEME_MODES = {
  LIGHT: 'light',
  DARK: 'dark',
  SYSTEM: 'system',
};

export const STORAGE_KEY = 'societyadmin_theme_mode';

export const DARK_DISPLAY = {
  accent: '#E5E5E5',
  button: '#525252',
  header: '#141414',
  vuetifyPrimary: '#E5E5E5',
  vuetifySecondary: '#525252',
  brand: '#E5E5E5',
  brandLt: 'rgba(255, 255, 255, 0.08)',
  brandGlow: 'rgba(255, 255, 255, 0.12)',
  btnColor: '#525252',
  btnColorLt: 'rgba(255, 255, 255, 0.06)',
  btnColorGlow: 'rgba(255, 255, 255, 0.1)',
};

export function getStoredThemeMode() {
  try {
    const mode = localStorage.getItem(STORAGE_KEY);
    if (mode && Object.values(THEME_MODES).includes(mode)) {
      return mode;
    }
  } catch (e) {
    console.error('Failed to read theme mode from storage', e);
  }
  return THEME_MODES.LIGHT;
}

export function getSystemPrefersDark() {
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

export function resolveIsDark(themeMode) {
  if (themeMode === THEME_MODES.DARK) return true;
  if (themeMode === THEME_MODES.SYSTEM) return getSystemPrefersDark();
  return false;
}

export function applyCssThemeVariables({ isDark, primaryColor, buttonColor }) {
  const root = document.documentElement;

  if (isDark) {
    root.style.setProperty('--brand', DARK_DISPLAY.brand);
    root.style.setProperty('--brand-lt', DARK_DISPLAY.brandLt);
    root.style.setProperty('--brand-glow', DARK_DISPLAY.brandGlow);
    root.style.setProperty('--btn-color', DARK_DISPLAY.btnColor);
    root.style.setProperty('--btn-color-lt', DARK_DISPLAY.btnColorLt);
    root.style.setProperty('--btn-color-glow', DARK_DISPLAY.btnColorGlow);
    root.style.setProperty('--sb-act-bdr', DARK_DISPLAY.accent);
    root.style.setProperty('--sb-act-bg', DARK_DISPLAY.brandLt);
    root.classList.add('dark');
    return;
  }

  root.style.setProperty('--brand', primaryColor);
  root.style.setProperty('--brand-lt', `${primaryColor}1A`);
  root.style.setProperty('--brand-glow', `${primaryColor}2E`);
  root.style.setProperty('--btn-color', buttonColor);
  root.style.setProperty('--btn-color-lt', `${buttonColor}1A`);
  root.style.setProperty('--btn-color-glow', `${buttonColor}2E`);
  root.style.setProperty('--sb-act-bdr', primaryColor);
  root.style.setProperty('--sb-act-bg', `${primaryColor}22`);
  root.classList.remove('dark');
}

export function applyDocumentThemeClass(isDark) {
  document.documentElement.classList.toggle('theme--dark', isDark);
  document.documentElement.classList.toggle('theme--light', !isDark);
  document.documentElement.classList.toggle('dark', isDark);
}

export function applyVuetifyTheme(vuetify, { isDark, primaryColor, buttonColor }) {
  if (!vuetify || !vuetify.framework) return;

  vuetify.framework.theme.dark = isDark;

  if (isDark) {
    const darkTheme = vuetify.framework.theme.themes.dark;
    darkTheme.primary = DARK_DISPLAY.vuetifyPrimary;
    darkTheme.secondary = DARK_DISPLAY.vuetifySecondary;
    darkTheme.background = '#0A0A0A';
    darkTheme.surface = '#171717';
    darkTheme.accent = '#D4D4D4';
    darkTheme.error = '#A3A3A3';
    darkTheme.warning = '#A3A3A3';
    darkTheme.info = '#D4D4D4';
    darkTheme.success = '#D4D4D4';
    return;
  }

  const lightTheme = vuetify.framework.theme.themes.light;
  lightTheme.primary = primaryColor;
  lightTheme.secondary = buttonColor;
}
